import { CHANGE_LANGUAGE } from '../redux/action/actionTypes'
import { getLanguageObject } from '../library/utils';
export function changeLanguage(lang) {
    return function (dispatch) {
        dispatch({ type: CHANGE_LANGUAGE, payload: getLanguageObject(lang) })
    }
}
